import { Directive } from '@angular/core';

@Directive({
  selector: '[libTest]'
})
export class TestDirective {

  constructor() { }

}
